import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "reactionAndTicker"
}
const _hoisted_2 = {
  key: 0,
  class: "tickers"
}
const _hoisted_3 = {
  key: 0,
  class: "stockTagsLength"
}
const _hoisted_4 = { class: "foot" }
const _hoisted_5 = { class: "leftAlign" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "rightAlign" }
const _hoisted_9 = { class: "icon_footer" }
const _hoisted_10 = { class: "icon_footer comment" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PostReactions = _resolveComponent("PostReactions")!
  const _component_PostTickers = _resolveComponent("PostTickers")!
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.fromOutside)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_PostReactions, {
            sourceId: _ctx.sourceId,
            onUpdateTotalCount: _ctx.handleTotalCountUpdate,
            reactions: _ctx.reactions,
            post: _ctx.post,
            selectedReaction: _ctx.currentReactionType
          }, null, 8, ["sourceId", "onUpdateTotalCount", "reactions", "post", "selectedReaction"]),
          (_ctx.processedStockTags.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processedStockTags.slice(0, 5), (stockTag, i) => {
                  return (_openBlock(), _createBlock(_component_PostTickers, {
                    key: i,
                    stockTag: stockTag
                  }, null, 8, ["stockTag"]))
                }), 128)),
                (_ctx.processedStockTags.length > 5)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, " +" + _toDisplayString(_ctx.processedStockTags.length - 5), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("a", {
          class: "icon_footer like",
          onMouseenter: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleMouseEnter && _ctx.handleMouseEnter(...args))),
          onMouseleave: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleMouseLeave && _ctx.handleMouseLeave(...args))),
          ref: "likeIconFooterRef"
        }, [
          (_ctx.hasUserReacted)
            ? (_openBlock(), _createBlock(_component_IconComponent, {
                key: 0,
                noRtlTransform: "",
                path: "/post_card",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.handleUnlikePost($event)), ["stop"])),
                className: "post_footer_icon full_width active",
                icon: "post_like_active.svg"
              }))
            : (_openBlock(), _createBlock(_component_IconComponent, {
                key: 1,
                noRtlTransform: "",
                path: "/post_card",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.handleLikePost($event, _ctx.currentReactionType)), ["stop"])),
                className: "post_footer_icon full_width",
                icon: "icons_like_outline.svg"
              })),
          _createTextVNode(" " + _toDisplayString(_ctx.totalReactions), 1)
        ], 544),
        (!_ctx.fromOutside)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.showLikeBox)
                ? (_openBlock(), _createBlock(_Teleport, {
                    key: 0,
                    to: _ctx.teleportTarget
                  }, [
                    _createElementVNode("div", {
                      class: "likeBox popover_content teleported-popover",
                      ref: "likeBoxRef",
                      onMouseenter: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleMouseEnter && _ctx.handleMouseEnter(...args))),
                      onMouseleave: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleMouseLeave && _ctx.handleMouseLeave(...args))),
                      style: _normalizeStyle(_ctx.popoverStyle)
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reactions, (reaction) => {
                        return (_openBlock(), _createElementBlock("figure", {
                          key: reaction,
                          id: "pf_like",
                          onClick: _withModifiers(($event: any) => (_ctx.handleIconClicked($event, reaction)), ["stop"])
                        }, [
                          _createVNode(_component_el_tooltip, {
                            content: reaction ? _ctx.$t(`common.reactions.${reaction}`) : '',
                            placement: "top"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("img", {
                                src: 
                    require(`../../../../../assets/images/reactions/${reaction}.png`)
                  
                              }, null, 8, _hoisted_7)
                            ]),
                            _: 2
                          }, 1032, ["content"])
                        ], 8, _hoisted_6))
                      }), 128))
                    ], 36)
                  ], 8, ["to"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("a", _hoisted_9, [
          _createVNode(_component_IconComponent, {
            onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.showRepostModal($event)), ["stop"])),
            path: "/post_card",
            icon: _ctx.repostCount > 0 ? `post_share.svg` : `outlined_post_share.svg`,
            noRtlTransform: ""
          }, null, 8, ["icon"]),
          _createTextVNode(" " + _toDisplayString(_ctx.repostCount), 1)
        ]),
        _createElementVNode("a", _hoisted_10, [
          _createVNode(_component_IconComponent, {
            onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.changeBottomView($event, true)), ["stop"])),
            path: "/post_card",
            icon: 
            _ctx.commentCount > 0 ? `post_comment.svg` : `outlined_post_comment.svg`
          ,
            noRtlTransform: ""
          }, null, 8, ["icon"]),
          _createTextVNode(" " + _toDisplayString(_ctx.commentCount), 1)
        ])
      ])
    ])
  ], 64))
}